import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Leaderboard from '../views/Leaderboard.vue';
import NotFoundComponent from '../views/NotFoundComponent.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/leaderboard',
    name: 'Leaderboard',
    component: Leaderboard,
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
];

const router = new VueRouter({
  routes,
  mode: 'history',
});

export default router;
